import { Alert, Dialog, DialogContent, Typography } from "@mui/material"

interface ErrorDialogProps {
  message: string | null
  onClose: () => void
}

export const ErrorDialog = (props: ErrorDialogProps) => {
  return (
    <Dialog open={!!props.message} onClose={props.onClose} fullWidth={true} maxWidth="md">
      <DialogContent>
        <Alert severity="error">
          <Typography variant="body1">{props.message}</Typography>
        </Alert>
      </DialogContent>
    </Dialog>
  )
}